import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalService {

    constructor() {
    }

    //格式化时间
    private durationFormatSubVal(val: any) {
        let valStr = val.toString();
        if (valStr.length < 2) {
            return '0' + valStr;
        }
        return valStr;
    }

    //格式化时间
    durationText(duration: any) {
        if (duration < 0) {
            return "Play";
        }
        let durationSecInt = Math.round(duration);
        return this.durationFormatSubVal(Math.floor(durationSecInt / 3600))
            + ":" + this.durationFormatSubVal(Math.floor((durationSecInt % 3600) / 60))
            + ":" + this.durationFormatSubVal(Math.floor(durationSecInt % 60));
    }

    //加载js
    loadScript(scriptUrl: string) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = scriptUrl;
        document.body.appendChild(script);
    }

    // 检查流地址是否可访问
    checkStreamUrl(url: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'get',
                mode: 'cors'
            }).then(res => {
                resolve(res.ok);
            }).catch(err => {
                reject(false);
            });
        });
    }

    /**
     * 获取文件后缀
     * @param filename string 文件名
     * @returns extension
     */
    getFileExtension(filename: string): string {
        if (!filename) {
            return '';
        }
        const filenameArr = filename.split('.');
        if (filenameArr.length == 0) {
            return '';
        } else {
            const extension = filenameArr.pop()!;
            return extension.toLowerCase();
        }
    }
}

